import React from 'react';
import { AlertCircle } from 'lucide-react';

import { cn } from '@epoch-ui/lib/utils';

const ErrorMessage = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, children, ...props }, ref) => {
  return (
    <div className="tw-mt-2 tw-flex tw-items-start tw-text-negative-foreground">
      <AlertCircle className="tw-mr-1 tw-size-4 tw-shrink-0" />
      <p
        ref={ref}
        className={cn('tw-m-0 tw-text-xs tw-font-normal tw-leading-4', className)}
        role="alert"
        {...props}
      >
        {children}
      </p>
    </div>
  );
});

export { ErrorMessage };
